export default {
  partnerList: [],
  partnerListCount: 0,
  partner: {},
  partnerListForCreate: []
}